/**
 * Level API
 *
 *
*/
import httpService from '@/api/httpService'

const levelApi = {
    // Level List
    // https://clpapi.tinkeredu.co.kr/static/docs/level.html#resources-level-policy_request_headers
    levelList() {
        return httpService.get('/outcome/level/policy/list')
    },
    // Level Detail
    // https://clpapi.tinkeredu.co.kr/static/docs/level.html#resources-level_http_request
    levelDetail() {
        return httpService.get('/reward/level/detail')
    },
   
}

export default levelApi